<template>
  <div>
    <vxe-grid
      ref="table"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
    >
      <template v-slot:toolbar_form>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title_logistics') || '对接物流平台' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              v-if="!disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="add()"
            >
              {{ $l('btn_add_logistics') || '添加' }}
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:displayIsDefault="{ row }">
        <div style="text-align: center;">
          <label
            :class="{
              'is-checked': row.isDefault == 'Y',
            }"
            class="el-checkbox"
            ><span
              class="el-checkbox__input "
              :class="{
                'is-checked': row.isDefault == 'Y',
              }"
              ><span class="el-checkbox__inner"></span></span
          ></label>
        </div>
      </template>

      <template v-slot:opt="{ row }">
        <el-tooltip
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="remove(row)"
            v-if="!disabled"
          />
        </el-tooltip>
        <el-tooltip
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="edit(row)"
            v-if="!disabled"
          />
        </el-tooltip>
        <el-tooltip
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i class="el-icon-view tool-btn" @click="view(row)" />
        </el-tooltip>
      </template>
    </vxe-grid>
    <EditMain
      v-if="editOptions.visible"
      :type="editOptions.type"
      :logisticsAccount="editOptions.logisticsAccount"
      :visible.sync="editOptions.visible"
      @confirm="confirm"
    ></EditMain>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
import EditMain from './Main.vue'
export default {
  components: { EditMain },
  mixins: [TableAutoHeight],
  props: {
    platformCode: { type: String, default: '' },
    logisticsAccount: { type: String, default: '[]' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableColumns: tableColumns(this),
      format: (n) => format(n),
      editOptions: {
        visible: false,
        type: '',
        logisticsAccount: { isDefault: 'N' },
      },
    }
  },
  computed: {
    height() {
      const h = this.tableHeight - 100
      return h <= 300 ? 300 : h
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    logisticsAccount() {
      this.getData()
    },
  },
  methods: {
    async getData() {
      this.tableData = JSON.parse(this.logisticsAccount || '[]') || []
    },
    async confirm(type, rowData) {
      if (rowData.isDefault === 'Y') {
        const { fullData } = this.$refs.table.getTableData()
        fullData.forEach((e) => {
          if (e.isDefault === 'Y') {
            e.isDefault = 'N'
          }
        })
      }
      if (type === 'edit') {
        console.log(rowData)
        const { fullData } = this.$refs.table.getTableData()
        const t_data = fullData.map((e) => {
          if (e._X_ID == rowData._X_ID) {
            e = { ...rowData }
          }
          return e
        })
        this.$refs.table.reloadData(t_data)
      } else {
        await this.$refs.table.insertAt(rowData, -1)
      }

      this.editOptions.visible = false
    },
    async add() {
      this.editOptions.type = 'add'
      this.editOptions.logisticsAccount = { isDefault: 'N' }
      this.editOptions.visible = true
    },
    remove(row) {
      this.$refs.table.remove(row)
    },
    edit(row) {
      this.editOptions.type = 'edit'
      this.editOptions.logisticsAccount = row
      this.editOptions.visible = true
    },
    view(row) {
      this.editOptions.type = 'detail'
      this.editOptions.logisticsAccount = row
      this.editOptions.visible = true
    },
    getTableData() {
      const data = this.$refs.table.getTableData()
      return data?.fullData || []
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
